<template>
  <div class="pa-6">
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Bản tóm tắt</v-tab>
      <v-tab class="tab-default" :key="2"> Chi tiết</v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1"> <ChartReportView /></v-tab-item>
        <v-tab-item :key="2"> <StudentReportView /></v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ChartReportView from './ChartReportView.vue'
import StudentReportView from './StudentReportView.vue'
export default {
  components: { ChartReportView, StudentReportView },
  data: () => ({ tab: null }),
  mounted() {
    this.fetch({ survey: this.$route.params.id, getAnswerText: true })
  },
  methods: {
    ...mapActions({
      fetch: 'surveyQuestion/fetch',
    }),
  },
}
</script>

<style></style>
